import React from 'react';
import HeroSection from '../../HeroSection';
import { homeObjFour } from './Data';

function About() {
  return (
    <>
      <HeroSection {...homeObjFour} />
    </>
  );
}

export default About;